/** FF017 乗込時確認書 — admin section titles */
export const SITE_ARRIVAL_SECTION_HEALTH_CHECKUP = '入社後の健康診断の日程';
export const SITE_ARRIVAL_SECTION_DORM_RENTALS = '宿舎利用リース備品';
export const SITE_ARRIVAL_SECTION_MEALS = '食事';
